<template>
  <v-card class="overflow-hidden" color="#F9F6F6" min-height="100vh">
    <v-row class="ma-0 roster-container px-2">
      <!-- ====== Filtros Desktop (md y arriba): sidebar sticky ====== -->
      <v-col cols="12" md="3" class="mb-4 mb-md-0 d-none d-md-block">
        <v-card elevation="0" class="filters">
          <template v-if="filtersLoading">
            <v-skeleton-loader class="px-4 py-4" type="list-item@15" />
          </template>
          <template v-else>
            <div v-for="(group, gIndex) in filters" :key="gIndex">
              <v-card-title class="pb-0">{{ group.title }}</v-card-title>

              <v-row
                v-for="(opt, index2) in group.options"
                :key="opt.id || index2"
                class="ma-0 my-4 px-4 opt"
                @click="toggleFilter(opt.id)"
              >
                <div
                  class="checkradio mr-2"
                  :class="selected_filters.includes(opt.id) ? 'checkradio-selected' : ''"
                >
                  <div class="inner-cheradio"></div>
                </div>
                <span class="filter-option">{{ opt.name }}</span>
              </v-row>
            </div>
          </template>
        </v-card>
      </v-col>

      <!-- ====== Filtros Mobile (xs/sm): expansion panel arriba del grid) ====== -->
      <v-col cols="12" class="d-md-none">
        <v-expansion-panels
          ref="mobileFilters"
          v-model="mobilePanel"
          flat
          accordion
          class="mb-2"
        >
          <v-expansion-panel>
            <v-expansion-panel-header disable-icon-rotate>
              <div class="d-flex align-center" style="gap:8px;">
                <v-icon>mdi-filter</v-icon>
                <span>Filtros</span>
                <v-chip v-if="selected_filters.length" small class="ml-2" color="primary" text-color="white">
                  {{ selected_filters.length }}
                </v-chip>
              </div>
              <template v-slot:actions>
                <v-icon>mdi-chevron-down</v-icon>
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-card elevation="0">
                <template v-if="filtersLoading">
                  <v-skeleton-loader class="px-4 py-4" type="list-item@6" />
                </template>
                <template v-else>
                  <div v-for="(group, gIndex) in filters" :key="'m-'+gIndex" class="px-2">
                    <v-card-title class="pb-0 pt-2">{{ group.title }}</v-card-title>

                    <v-row
                      v-for="(opt, index2) in group.options"
                      :key="opt.id || index2"
                      class="ma-0 my-3 px-2 opt"
                      @click="toggleFilter(opt.id)"
                    >
                      <div
                        class="checkradio mr-2"
                        :class="selected_filters.includes(opt.id) ? 'checkradio-selected' : ''"
                      >
                        <div class="inner-cheradio"></div>
                      </div>
                      <span class="filter-option">{{ opt.name }}</span>
                    </v-row>
                  </div>
                </template>

                <!--v-row class="ma-0 px-3 pb-2 pt-1">
                  <v-spacer/>
                 
                  <v-btn
                    small rounded text
                    @click="clearFilters"
                    class="mr-2"
                  >Limpiar</v-btn>
                   <v-btn
                    small rounded color="primary"
                    class="elevation-0"
                    @click="resetAndLoad"
                  >Aplicar</v-btn>
                </v-row-->
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <!-- ====== Contenedor principal (grid) ====== -->
      <v-col cols="12" md="9" class="pl-md-0">
        <grid :posts="posts" :loading="loading"/>

        <!-- Sentinel para scroll infinito -->
        <div ref="sentinel" style="height: 1px;"></div>
        
        <!-- Estado de carga / fin -->
        <!-- 🔹 Spinner sólo cuando estoy cargando MÁS posts (no la primera vez) -->
        <div class="py-6 text-center" v-if="loading && posts.length > 0">
          <v-progress-circular indeterminate color="primary" size="24" />
        </div>
        <div class="py-6 text-center grey--text" v-else-if="!posts.length && !loading">
          Sin resultados.
        </div>

      </v-col>
    </v-row>

    <!-- ====== FAB Mobile: Subir y abrir filtros ====== -->
    <v-btn
      v-if="showScrollTop && isMobile"
      fab small fixed bottom right color="primary"
      class="elevation-6 mb-6 mr-4"
      @click="scrollTopAndOpenFilters"
      aria-label="Abrir filtros"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import axios from 'axios'
import Grid from './Grid.vue'

export default {
  props:{
    selected_department:String
  },
  watch:{
    selected_department:{
      handler(){
        this.fetchPosts()
      }, deep:true
    }
  },
  components: { grid: Grid },
  data () {
    return {
      filters: [],
      selected_filters: [],

      posts: [],
      page: 1,
      itemsPerPage: 12,
      loading: true,
      hasMore: true,
      io: null, // IntersectionObserver

      filtersLoading: true,

      // UI state mobile
      mobilePanel: false,        // v-expansion-panels model (array para accordion en v2)
      showScrollTop: false,   // mostrar FAB en mobile al hacer scroll
      scrollThreshold: 420    // px para mostrar FAB
    }
  },
  computed: {
    apiBase () {
      return process.env.VUE_APP_BACKEND_ROUTE
    },
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  mounted () {
    // Carga filtros + datos + IO
    this.fetchCategories()
      .catch(() => {})
      .finally(() => {
        this.readFiltersFromRoute()
        this.resetAndLoad()
        this.mountObserver()
      })

    // Listener de scroll para FAB
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  },
  beforeDestroy () {
    if (this.io) {
      this.io.disconnect()
      this.io = null
    }
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    syncRouteFromFilters () {
      const query = { ...this.$route.query }

      if (this.selected_filters.length) {
        query.categories = this.selected_filters.join(',')
      } else {
        delete query.categories
      }

      this.$router.replace({ query })
    },
    readFiltersFromRoute () {
      const { categories } = this.$route.query
      if (!categories) {
        this.selected_filters = []
        return
      }

      // "1,3,5" -> [1,3,5]
      this.selected_filters = categories
        .split(',')
        .map(v => v.trim())
        .filter(Boolean)
        .map(v => {
          const n = Number(v)
          return Number.isNaN(n) ? v : n
        })
    },
    // ====== Categorías (para filtros) ======
    async fetchCategories () {
      try {
        const url = `${this.apiBase}api/v1/categories?itemsPerPage=999`
        const { data } = await axios.get(url)
        const list = Array.isArray(data?.data) ? data.data : []

        const groupsMap = new Map()
        for (const cat of list) {
          const type = (cat.type || 'Otras').toString()
          if (!groupsMap.has(type)) groupsMap.set(type, [])
          groupsMap.get(type).push({ id: cat.id, name: cat.name })
        }

        this.filters = Array.from(groupsMap.entries()).map(([type, options]) => ({
          title: type,
          options
        }))
      } finally {
        this.filtersLoading = false
      }
    },

    // ====== Scroll infinito ======
    mountObserver () {
      const target = this.$refs.sentinel
      if (!target) return

      this.io = new IntersectionObserver((entries) => {
        const entry = entries[0]
        if (entry && entry.isIntersecting) {
          this.loadMore()
        }
      }, {
        root: null,
        rootMargin: '600px 0px 0px 0px',
        threshold: 0
      })

      this.io.observe(target)
    },

    // Togglear categoría
    toggleFilter (catId) {
      const idx = this.selected_filters.indexOf(catId)
      if (idx >= 0) {
        this.selected_filters.splice(idx, 1)
      } else {
        this.selected_filters.push(catId)
      }
      this.resetAndLoad()
      this.mobilePanel = false
      this.syncRouteFromFilters()
    },

    clearFilters () {
      this.selected_filters = []
      this.resetAndLoad()
      this.syncRouteFromFilters() 
    },

    resetAndLoad () {
      this.page = 1
      this.posts = []
      this.hasMore = true
      this.fetchPosts()
    },

    loadMore () {
      if (this.loading || !this.hasMore) return
      this.page += 1
      this.fetchPosts(true)
    },

    // ====== Fetch de posts ======
    async fetchPosts (append = false) {
      //if (this.loading) return
      this.loading = true

      try {
        const params = new URLSearchParams()
        params.set('page', String(this.page))
        params.set('itemsPerPage', String(this.itemsPerPage))
        params.set('sort', '-id')

        if (this.selected_filters.length) {
          params.set('filter[categories]', this.selected_filters.join(','))
        }

        if(this.selected_department!=''){
          params.set('filter[influencer.department]', this.selected_department)
        }

        const url = `${this.apiBase}api/v1/roster?${params.toString()}`
        const { data } = await axios.get(url)
        const rows = Array.isArray(data?.data) ? data.data : []

        if (!append) this.posts = rows
        else this.posts = this.posts.concat(rows)

        this.hasMore = rows.length === this.itemsPerPage
      } catch (_) {
        this.hasMore = false
      } finally {
        this.loading = false
      }
    },

    // ====== FAB helpers ======
    onScroll () {
      this.showScrollTop = (window.pageYOffset || document.documentElement.scrollTop || 0) > this.scrollThreshold
    },
    scrollTopAndOpenFilters () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style>
/* ===== Filtros / checks ===== */
.checkradio{
  border: solid 1px #18181B1F;
  border-radius: 50%;
  height:16px; width:16px;
  box-shadow: 0px 2px 2px -1px rgba(0,0,0,.2) !important;
}
.checkradio-selected{ border-color:#F48A5A; background:#FA9365; }
.inner-cheradio{ height:6px; width:6px; background:white; border-radius:50%; margin:4px; }
.filter-option{ font-size:15px; line-height:16px; text-transform:none !important; }
.filters .v-card__title{ font-size:16px; text-transform:none !important; }
.filters {
    height: calc(100vh - 150px);
    position: fixed;
    width: 23vw;
    overflow: scroll;
    overflow-x: hidden;
}

.opt:hover .checkradio{ border-color:#F48A5A; }

/* Mobile: el panel ya controla el alto */
@media (max-width: 960px){
  .filters{
    position: static;
    height: auto !important;
    max-height: none;
    top: auto;
  }
}
</style>
